// ============================================================
// chatData.js — AALI GROUP Chatbot Knowledge Base
// Centralized business data extracted from all pages.
// ============================================================

export const WHATSAPP_NUMBER = "918341085415"; // with country code, no +
export const WHATSAPP_WELCOME_MSG =
  "Hello! I'm reaching out from the AALI GROUP website (aaligroup.co). I'd like to know more about your services.";

export const COMPANY_INFO = {
  name: "AALI GROUP",
  tagline: "Building Tomorrow, Today",
  description:
    "AALI GROUP is a diversified conglomerate based in Guntur, Andhra Pradesh, spanning technology, infrastructure, media, luxury retail, and social impact verticals.",
  founded: "Founded by Azagar Ali Shaik",
  employees: "300+ jobs created",
  email: "info@aaligroup.co",
  phone: "+91 8341085415",
  landline: "+91 863 461 1770",
  address: "Guntur, Andhra Pradesh, India",
  website: "https://aaligroup.co",
};

export const FOUNDER_INFO = {
  name: "Azagar Ali Shaik",
  title: "Founder & Chief Executive Officer",
  experience: "10+ years",
  vision:
    "Success is not just about building businesses; it's about empowering people, uplifting communities, and leaving a legacy of positive impact.",
  philosophy:
    "Visionary entrepreneur with over 10 years of experience building successful businesses across technology, infrastructure, media, luxury retail, and social impact initiatives.",
};

export const SUBSIDIARIES = [
  {
    id: "aalitech",
    name: "AALITECH",
    industry: "Technology & Digital Marketing",
    route: "/companies/aalitech",
    externalSite: "https://aalitech.co/",
    description:
      "A forward-thinking digital agency offering digital marketing (SEO, Social Media, PPC), web development & design, and scalable tech solutions.",
    services: ["Digital Marketing", "SEO", "Social Media Marketing", "PPC Advertising", "Web Development", "Web Design"],
    keywords: ["tech", "technology", "digital", "marketing", "seo", "web", "website", "development", "aalitech", "software"],
  },
  {
    id: "aaliconsultancy",
    name: "AALI CONSSULTANCY",
    industry: "Job & Education Consultancy",
    route: "/companies/aaliconssultancy",
    description:
      "Your trusted partner for employment opportunities and education pathways — job placements in India & overseas, overseas employment assistance, and college admissions guidance.",
    services: ["Job Placements (India & Overseas)", "Overseas Employment", "Management Quota Admissions", "Admissions in India & Abroad"],
    keywords: ["consult", "consulting", "consultancy", "conssultancy", "job", "jobs", "placement", "employment", "overseas", "abroad", "education", "admission", "admissions", "college", "career"],
  },
  {
    id: "aalibuilders",
    name: "AALI BUILDERS",
    industry: "Infrastructure & Real Estate",
    route: "/companies/aalibuilders",
    description:
      "Sustainable development and engineering excellence — building tomorrow's global infrastructure through innovative construction and real estate projects.",
    services: ["Construction", "Real Estate Development", "Sustainable Infrastructure", "Engineering Projects"],
    keywords: ["infra", "infrastructure", "construction", "building", "real estate", "property", "development", "engineer"],
  },
  {
    id: "aalimovies",
    name: "AALI MOVIES",
    industry: "Film Production",
    route: "/companies/aalimovies",
    description:
      "Film production house creating cinematic content with global impact — delivering stories that inspire and entertain.",
    services: ["Film Production", "Movie Distribution", "Cinematic Storytelling"],
    keywords: ["movie", "movies", "film", "cinema", "production", "entertainment", "aalimovies"],
  },
  {
    id: "aalifilmz",
    name: "AALI FILMZ",
    industry: "Digital Content & Media",
    route: "/companies/aalifilmz",
    description:
      "Creative digital content studio producing modern narratives for digital platforms — storytelling reimagined for the digital age.",
    services: ["Digital Content Production", "Video Production", "Creative Storytelling", "Digital Media"],
    keywords: ["filmz", "film", "digital content", "video", "content", "media", "studio", "creative"],
  },
  {
    id: "aalimusic",
    name: "AALI MUSIC",
    industry: "Music & Audio Production",
    route: "/companies/aalimusic",
    description:
      "Music label and audio production house crafting timeless melodies and rhythm-driven excellence for global audiences.",
    services: ["Music Production", "Audio Recording", "Music Label", "Artist Management"],
    keywords: ["music", "audio", "sound", "label", "recording", "artist", "melody", "aalimusic"],
  },
  {
    id: "aaligoldjewelz",
    name: "AALI GOLD JEWELZ",
    industry: "Luxury Jewellery",
    route: "/companies/aaligoldjewelz",
    description:
      "Luxury jewellery brand redefining opulence through eternal elegance and masterful craftsmanship — premium gold and fine jewellery.",
    services: ["Gold Jewellery", "Fine Jewellery", "Luxury Accessories", "Custom Jewellery"],
    keywords: ["gold", "jewel", "jewels", "jewelry", "jewellery", "luxury", "ornament", "ring", "necklace"],
  },
  {
    id: "aalitrustz",
    name: "AALI TRUSTZ",
    industry: "Social Impact & NGO",
    route: "/companies/aalitrustz",
    description:
      "Social impact and sustainable development initiative — empowering communities through education, health, and positive change.",
    services: ["Community Development", "Education Initiatives", "Health Programs", "Social Impact", "Sustainability"],
    keywords: ["trust", "trustz", "social", "community", "ngo", "charity", "welfare", "impact", "development"],
  },
];

export const INDUSTRIES = [
  { name: "Technology & Consulting", route: "/industries/tech-cons", companies: ["AALITECH", "AALI CONSSULTANCY"] },
  { name: "Infrastructure", route: "/industries/builders-dev", companies: ["AALI BUILDERS"] },
  { name: "Media & Entertainment", route: "/industries/media-entertainment", companies: ["AALI MOVIES", "AALI FILMZ", "AALI MUSIC"] },
  { name: "Luxury Retail", route: "/industries/luxury-retail", companies: ["AALI GOLD JEWELZ"] },
  { name: "Social Impact", route: "/industries/social-impact", companies: ["AALI TRUSTZ"] },
];

export const CAREERS_INFO = {
  description:
    "AALI GROUP welcomes passionate professionals across all business verticals — technology, infrastructure, entertainment, consulting, and social impact.",
  benefits: ["Dynamic work environment", "Growth opportunities", "Cross-industry exposure", "Innovation-driven culture"],
  howToApply: "Visit our Careers page or reach us directly via WhatsApp or email.",
  route: "/careers",
};

export const INVESTORS_INFO = {
  description:
    "AALI GROUP presents exciting investment opportunities across its diversified portfolio spanning high-growth sectors.",
  sectors: ["Technology", "Infrastructure", "Media & Entertainment", "Luxury Retail", "Social Impact"],
  contact: "Reach out to our investor relations team via email or WhatsApp for detailed discussions.",
  route: "/investors",
};

export const VISION_MISSION = {
  vision:
    "To be a globally recognized conglomerate that creates sustainable value across diverse industries while making a meaningful difference in the communities we serve.",
  mission:
    "To deliver exceptional products and services that exceed expectations, foster innovation that drives progress, and create opportunities that empower people.",
};

// Global office locations (added from GlobalLocations.js)
export const GLOBAL_LOCATIONS = [
  {
    id: 1,
    country: "United States",
    city: "New York",
    address: "AALI GROUP Americas HQ, 350 Fifth Avenue, Suite 5500, New York, NY 10118",
    lat: 40.7128,
    lng: -74.0060,
    phone: "+1 (212) 555-0123",
    email: "info@aaligroup.co",
    type: "International Office",
    flag: "🇺🇸",
  },
  {
    id: 2,
    country: "United Arab Emirates",
    city: "Dubai",
    address: "AALI GROUP Middle East, Burj Khalifa, 123rd Floor, Downtown Dubai, UAE",
    lat: 25.2048,
    lng: 55.2708,
    phone: "+971 4 123 4567",
    email: "info@aaligroup.co",
    type: "Regional HQ - Middle East",
    flag: "🇦🇪",
  },
  {
    id: 3,
    country: "Singapore",
    city: "Singapore",
    address: "AALI GROUP Asia Pacific, Marina Bay Financial Centre, Tower 3, Singapore 018982",
    lat: 1.3521,
    lng: 103.8198,
    phone: "+65 6789 0123",
    email: "info@aaligroup.co",
    type: "Regional HQ - Asia Pacific",
    flag: "🇸🇬",
  },
  {
    id: 4,
    country: "Malaysia",
    city: "Kuala Lumpur",
    address: "AALI GROUP Malaysia, Petronas Twin Towers, Level 45, Kuala Lumpur 50088",
    lat: 3.1390,
    lng: 101.6869,
    phone: "+60 3 1234 5678",
    email: "info@aaligroup.co",
    type: "ASEAN Operations",
    flag: "🇲🇾",
  },
  {
    id: 5,
    country: "India",
    city: "New Delhi",
    address: "AALI GROUP India - North Region, Connaught Place, New Delhi - 110001",
    lat: 28.7041,
    lng: 77.1025,
    phone: "+91 11 4567 8901",
    email: "info@aaligroup.co",
    type: "Operations - North India",
    flag: "🇮🇳",
  },
  {
    id: 6,
    country: "India",
    city: "Mumbai",
    address: "AALI GROUP India - West Region, Bandra Kurla Complex, Mumbai - 400051",
    lat: 19.0760,
    lng: 72.8777,
    phone: "+91 22 6789 0123",
    email: "info@aaligroup.co",
    type: "Operations - West India",
    flag: "🇮🇳",
  },
  {
    id: 7,
    country: "India",
    city: "Bangalore",
    address: "AALI GROUP India - South Region, UB City, Lavelle Road, Bangalore - 560001",
    lat: 12.9716,
    lng: 77.5946,
    phone: "+91 80 4567 8901",
    email: "info@aaligroup.co",
    type: "Operations - South India",
    flag: "🇮🇳",
  },
  {
    id: 8,
    country: "India",
    city: "Chennai",
    address: "AALI GROUP India - Tamil Nadu, Express Avenue, Royapettah, Chennai - 600014",
    lat: 13.0827,
    lng: 80.2707,
    phone: "+91 44 6789 0123",
    email: "info@aaligroup.co",
    type: "Operations - East Coast",
    flag: "🇮🇳",
  },
  {
    id: 9,
    country: "India",
    city: "Hyderabad",
    address: "AALI GROUP India - Telangana, HITEC City, Hyderabad - 500081",
    lat: 17.3850,
    lng: 78.4867,
    phone: "+91 83 4108 5415",
    email: "info@aaligroup.co",
    type: "Head Quarters - Telangana",
    flag: "🇮🇳",
  },
  {
    id: 10,
    country: "India",
    city: "Guntur",
    address: "AALI GROUP India - Syamala Nagar, Guntur, Andhra Pradesh, 522006",
    lat: 16.3067,
    lng: 80.4365,
    phone: "+91 83 4108 5415",
    email: "info@aaligroup.co",
    type: "Operational Office - Andhra Pradesh",
    flag: "🇮🇳",
  },
];

// Helper function to get location summary for chatbot
export const getLocationsSummary = () => {
  const countries = [...new Map(GLOBAL_LOCATIONS.map(loc => [loc.country, loc.flag])).entries()];
  const countryList = countries.map(([country, flag]) => `${flag} ${country}`).join(", ");
  const totalOffices = GLOBAL_LOCATIONS.length;
  return `AALI GROUP has ${totalOffices} offices across ${countries.length} countries: ${countryList}. Our major locations include New York (USA), Dubai (UAE), Singapore, Kuala Lumpur (Malaysia), and multiple offices across India (New Delhi, Mumbai, Bangalore, Chennai, Hyderabad, Guntur).`;
};

export const QUICK_SUGGESTIONS = [
  { label: "🏢 Our Services", query: "What services does AALI GROUP offer?" },
  { label: "📞 Contact Us", query: "How can I contact AALI GROUP?" },
  { label: "💼 Careers", query: "Are there any career opportunities at AALI GROUP?" },
  { label: "🏭 Businesses", query: "Tell me about AALI GROUP businesses" },
  { label: "📈 Investors", query: "What are the investment opportunities at AALI GROUP?" },
  { label: "📍 Office Locations", query: "Where are your global offices located?" },
  { label: "🤝 Support", query: "I need support or help" },
];

export const GREETING_MESSAGE =
  "👋 Welcome to **AALI GROUP**! I'm your virtual assistant, here to help you explore our businesses, services, careers, locations, and more.\n\nHow can I assist you today?";